import React from 'react';
import styled from 'styled-components';
import { ReactComponent as LogoSvg } from './logo.svg';
import { ReactComponent as LogoInvertedImage } from './logo_inverted.svg';
import { forSmallPhoneOnly } from '../../utils/mediaqueries';

export const Logo = props => (
	<LogoImage {...props} width="200px" height="41px" />
);
export const SecondaryLogo = props => (
	<SecondaryLogoImage {...props} width="150px" height="34px" />
);
export const LogoInverted = props => (
	<LogoInvertedImage {...props} width="200px" height="41px" />
);

const LogoImage = styled(LogoSvg)`
	${forSmallPhoneOnly`
		width: 103px;
		height: 31px;
	`}
`
const SecondaryLogoImage = styled(LogoSvg)`
	${forSmallPhoneOnly`
		width: 103px;
		height: 31px;
	`}
`;
